import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #LIST
\*------------------------------------ */
:host {
  display: var(--cat-c-list-display, block);
}

/**
 * 1) Generic stacked list that allows for styling of borders in between items
 */
.cat-c-list {
  padding: 0;
  margin: 0;
  list-style: none;
  cursor: auto;
  height: var(--cat-list-body-height, auto);
  overflow: var(--cat-list-body-overflow, auto);
}

.cat-c-list.cat-c-list--steppedmegamenu {
  padding: 0;
  margin: 0;
  padding-block: var(--cat-c-list-padding-block, var(--cat-space-x-small));
  list-style: none;
  cursor: auto;
  width: var(--cat-list-width, auto);
  max-width: var(--cat-list-max-width, 100%);
  height: var(--cat-list-height, 100%);
  max-height: calc(100vh - var(--size-base-unit) * 2 - var(--cat-navbar-height, calc(var(--size-base-unit) * 7)));
  overflow-y: auto;
  box-shadow: var(--cat-c-list-box-shadow, var(--cat-theme-box-shadow-sm));
  --cat-c-list-display: contents;
}
.cat-c-list.cat-c-list--steppedmegamenu::-webkit-scrollbar {
  width: calc(var(--size-base-unit) * 0.5);
  flex-shrink: 0;
  border-radius: calc(var(--size-base-unit) * 0.25);
  background: var(--cat-theme-color-background-subtle-hover);
  box-shadow: var(0 0 2px 0 #ffffff, 0 0 2px 0 #ffffff, var(--cat-list-scroll-shadow));
}
.cat-c-list.cat-c-list--steppedmegamenu::-webkit-scrollbar-track {
  border-radius: calc(var(--size-base-unit) * 1.5);
  background: var(--cat-theme-color-background-subtle);
  margin-inline-start: var(--cat-table-scrollbar-margin-left);
  margin-block-start: var(--cat-table-scrollbar-margin-top);
}
.cat-c-list.cat-c-list--steppedmegamenu::-webkit-scrollbar-thumb {
  background: var(--cat-theme-color-background-subtle-hover);
  border-radius: calc(var(--size-base-unit) * 1.5);
}

.cat-c-list--drawer-before {
  display: flex;
  flex-direction: row;
  gap: calc(var(--size-base-unit) * 1);
  align-items: center;
  padding-block: var(--cat-c-list-mobile-drawer-before-padding-block, calc(var(--size-base-unit) * 0.5));
  padding-inline: var(--cat-c-list-mobile-drawer-before-padding-inline, calc(var(--size-base-unit) * 1));
  cursor: pointer;
  color: var(--cat-list-header-slot-color, inherit);
}

/**
 * 1) Container that becomes a scrolling carousel of components that you place inside when not enough room exists for all to display
 * 2) Wrapper needed around base list for shadows
 */
.cat-c-list-overflow-wrapper {
  overflow: auto;
  position: relative;
  /**
   * Left overflow gradient for the overflow list
   */
  /**
   * Right overflow gradient for the overflow list
   */
}
.cat-c-list-overflow-wrapper.cat-is-overflow-left:before {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-subtle) 0%, var(--cat-theme-color-background-transparent-subtle) 81.31%);
  height: calc(100% - var(--cat-list-scroll-padding, calc(var(--size-base-unit) * 0)));
  inset-block-start: 0;
  inset-inline-start: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: 1;
}
.cat-c-list-overflow-wrapper.cat-is-overflow-right:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-transparent-subtle) 0%, var(--cat-theme-color-background-subtle) 81.31%);
  height: calc(100% - var(--cat-list-scroll-padding, calc(var(--size-base-unit) * 0)));
  inset-block-start: 0;
  inset-inline-end: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: 1;
}

/**
 * Overflow list with subtle shadow
 */
.cat-c-list-overflow-wrapper--shadow-subtle {
  /**
   * Left overflow gradient for the overflow list
   */
  /** 
   * Right overflow gradient for the overflow list
   */
}
.cat-c-list-overflow-wrapper--shadow-subtle.cat-is-overflow-left:before {
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-subtle) 0%, transparent 100%);
}
.cat-c-list-overflow-wrapper--shadow-subtle.cat-is-overflow-right:after {
  background: linear-gradient(var(--rtlGradientToRight, 90deg), transparent 0%, var(--cat-theme-color-background-subtle) 100%);
}

/**
 * Horizontal list
 * 1) Displays list item in a row
 */
.cat-c-list--horizontal {
  display: flex;
  flex-wrap: wrap;
  gap: var(--cat-space-x-small);
}

/**
 * Overflow list
 * 1) Displays list item in a row that scrolls if the wrapper overflows
 */
.cat-c-list--overflow {
  flex-wrap: nowrap;
  overflow: auto;
  padding-block-end: var(--cat-list-scroll-padding, 0);
}

.cat-c-list-header--back__button {
  margin-inline-start: calc(var(--size-base-unit) * 1);
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: var(--cat-list-header-slot-color, inherit);
}

.cat-c-list:not(.cat-c-list--has-list-header-slot) [part=part-list-header], .cat-c-list:not(.cat-c-list-has-list-item-drawer) [part=before] {
  display: none;
}
`;
       